// /**
//  * Create and Edit Order
//  */

import React, { useState, useEffect } from 'react';

// components
import { useForm } from 'react-hook-form';
import { isEmpty } from 'lodash';
// UI
import {
  Grid,
  Button,
  Paper,
  Typography,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  Divider,
  Box,
  TextField,
} from '@material-ui/core';
import Modal from '../../components/Modal';
import Add from './components/add';
import AddVitrin from './components/addVitrin';
import jMoment from 'moment-jalaali';
import classes from './index.module.scss';

// Icon
import Icon from '@mdi/react';
import { mdiClose, mdiPaperclip } from '@mdi/js';
// Type
import {
  ParcelItems,
  PayloadCreate,
} from '../parcelsSender/interfaces';
import { AddItemCreateParcel } from '../parcels/interfaces';

// helpers'
import {
  removeEmptyValueObject,
  convertPersianDigit2English,
  getCurrentTime,
  getVVIPTime
} from '../../utils/helpers';

import { useHistory } from 'react-router-dom';
import handleNotification from '../../utils/handleNotfication';
import handleError from '../../utils/handleError';
import {
  createOrderItemsPayload,
  Order,
  OrderItems,
  orderItemsCreate,
  UpdateOrderPayload,
} from '../orders/interfaces';
import CustomerInfo from '../../components/sections/createOrder/customerInfo';
import ProductList from '../../components/sections/createOrder/productList';
import OrderInfo from '../../components/sections/createOrder/orderInfo';
import OrderInputs from '../../components/inputs/orderInputs';
import FileWithLink from '../../components/inputs/fileWithLink';
import ConfirmModal from '../../components/Modal/confirm';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import getOrderFileReq from 'client-sdk/src/orders/files'
import linkValidation from '../../utils/validations/linkValidation';
import theme from '../../theme';
import VideoModal from '../../components/Modal/video';
import downloadVideo from 'client-sdk/src/video/download';
import { Helmet } from 'react-helmet';

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

type Props = {
  create: (body: any) => void;
  onClose: () => void;
  warehouseId: number;
  createParcelsDispatch: (payload: PayloadCreate) => void;
  getOrderDispatch: (payload: { id: number }) => void;
  orderItemsList?: OrderItems[];
  getOrderItemsDispatch: (payload: any) => void;
  createOrderItemDispatch: (payload: createOrderItemsPayload) => void;
  updateOrderDispatch: (payload: UpdateOrderPayload) => void;
  clearOrderDispatch: () => void;
  order: Order;
  match: any;
};

type Inputs = {
  agentName: string;
  agentPhoneNumber: string;
  deliveryDate: string | Date | null;
  destinationId: number;
  orderType: string | null;
  orderTplType: string;
  id: number;
  origin: string | number;
  destination: string;
  customerName: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  customerPhoneNumber: string;
  customerProvince: any;
  customerCity: string;
  customerZipCode: string;
  deliveryType: string;
  trackingCode: string;
  customerAddress: string;
  description: string;
  items: ParcelItems[];
  deliveryTime: string | null;
  deliveryStartTime: string | null;
  deliveryEndTime: string | null;
  cost: string;
  weight: string;
  orderValue: string;
  packageCode: string;
  deliveryCode: string;
  codPaymentCode: string,
  location: Location
};

type Location = {
  lat: number | null;
  lng: number | null;
};

const day = new Date().getDay()

function CreateOrder(props: Props) {
  const history = useHistory();
  const form = useForm<Inputs>({
    defaultValues: {
      orderType: 'WITHOUT_CENTER',
      orderTplType: "RONAD",
      deliveryDate: null,
      deliveryTime: '',
      deliveryStartTime: null,
      deliveryEndTime: null,
      origin: "",
      destination: '',
      customerName: '',
      customerNationalCode: '',
      customerMobileNumber: '',
      customerPhoneNumber: '',
      customerProvince: '',
      customerCity: '',
      customerZipCode: '',
      deliveryType: '',
      trackingCode: '',
      customerAddress: '',
      description: '',
      cost: '',
      weight: '',
      orderValue: '',
      packageCode: '',
      deliveryCode: '',
      codPaymentCode: '',
      location: {
        lat: null,
        lng: null
      }
    },
  });
  const {
    handleSubmit,
    errors,
    watch,
    setValue,
    getValues,
    register,
    control,
    reset,
  } = form;
  // Checkbox States
  const [deliveryLocationType, setDeliveryLocationType] = useState<boolean>(false)
  const [cod, setCod] = useState(false);
  const [isFulfillmentService, setIsFulfillmentService] = useState(false);

  const [invoiceLink, setInvoiceLink] = useState<any>("");
  const [invoiceFile, setInvoiceFile] = useState("");
  const [invoiceFileName, setInvoiceFileName] = useState(null);
  const [labelLink, setLabelLink] = useState<any>("");
  const [labelFile, setLabelFile] = useState("");
  const [labelFileName, setLabelFileName] = useState(null);
  const [notifType, setNotifType] = useState("");
  const [isInvoiceFileChange, setIsInvoiceFileChange] = useState(false);
  const [isLabelFileChange, setIsLabelFileChange] = useState(false);

  const [dialog, setDialog] = useState<string>("");
  const [items, setItems] = useState<any>([]);
  const [itemDeleted, setItemDeleted] = useState<any>({});
  const [id, setId] = useState<any>(1);
  const [itemsInfo, setItemsInfo] = useState<any>([]);
  const [location, setLocations] = useState<Location | undefined>({
    lat: 0, lng: 0
  });
  const [formData, setFormData] = useState<any>(null);
  const [orderId] = useState<number>(props.match.params.id);
  const [editMode, setEditMode] = useState(false as boolean);
  const [isVitrinOrderItem, setIsVitrinOrderItem] = useState(false as boolean);
  const [order, setOrder] = useState<Order>({})
  const [orderItems, setOrderItems] = useState()
  const [submitLoading, setSubmitLoading] = useState(false)
  const [video, setVideo] = useState()
  const [videoLoading, setVideoLoading] = useState(false)

  //Force update hack Aryan
  const [updateCount, setUpdateCount] = useState(0);



  useEffect(() => {
    if (orderId) {
      setEditMode(true);
    }
  }, []);
  useEffect(() => {
    if (editMode) {
      getOrder({ id: orderId });
      getOrderItems({ 'orderId.equals': orderId, size: 1000 });
    }
  }, [editMode]);
  useEffect(() => {
    if (!isEmpty(order)) {
      const {
        orderType,
        deliveryDate,
        deliveryStartTime,
        deliveryEndTime,
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerMobileNumber,
        customerProvince,
        customerZipCode,
        trackingCode,
        codValue,
        description,
        fulfillmentWarehouseId,
        customerLat,
        customerLon,
        paymentType,
        weight,
        orderValue,
        packageCode,
        deliveryCode,
        codPaymentCode,
        orderTPLType,
        receiptFileName,
        labelFileName,
        receiptUrl,
        fulfillmentAttachmentUrl
      } = order;

      const payload = {
        orderType,
        deliveryDate,
        deliveryStartTime: deliveryDate + ' ' + deliveryStartTime,
        deliveryEndTime: deliveryDate + ' ' + deliveryEndTime,
        deliveryTime:
          deliveryStartTime === '11:00:00'
            ? '11-15'
            : deliveryStartTime === '16:00:00'
              ? '16-20'
              : '',
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerProvince,
        customerMobileNumber,
        customerZipCode,
        trackingCode,
        description,
        cost: codValue,
        origin: fulfillmentWarehouseId,
        destination: null,
        weight,
        orderValue,
        packageCode,
        orderTplType: orderTPLType ? orderTPLType : "RONAD",
        deliveryCode,
        codPaymentCode,
      };
      setInvoiceFileName(receiptFileName);
      setLabelFileName(labelFileName)
      setInvoiceLink(receiptUrl)
      setLabelLink(fulfillmentAttachmentUrl)
      if (order.deliveryLocationType == "IN_RONAD") {
        setDeliveryLocationType(true)
      }
      if (paymentType === 'COD') {
        setCod(true);
      } else {
        setCod(false);
      }
      if (order.fulfillmentLineId) {
        setIsFulfillmentService(true);
      }
      const location = {
        lat: Number(customerLat),
        lng: Number(customerLon),
      };
      if (location.lat && location.lng) {
        handleLocations(location);
      }
      reset(payload);
    }
  }, [order]);
  useEffect(() => {
    if (editMode && orderItems) {
      setItemsInfo(orderItems);
    }
  }, [orderItems]);
  useEffect(() => {
    if (deliveryLocationType) {
      setValue("customerAddress", "تهران، محله شادآباد، خیابان ١٧ شهریور، بین شهدای اسلامی و بسیج مستضعفین، شرکت روناد")
      setValue("customerProvince", "تهران")
      setValue("customerCity", "تهران")
      setNotifType("deliveryLocation")
    } else {
      setValue("customerAddress", "")
      setNotifType("")
    }
  }, [deliveryLocationType]);
  useEffect(() => {
    if (getValues("deliveryType") == "COURIER") {
      setNotifType("COURIER")
    } else {
      setNotifType("")
    }
  }, [getValues("deliveryType")]);
  // useEffect(() => {
  //   if (!isFulfillmentService) {
  //     onLabelDelete()
  //   }
  // }, [isFulfillmentService])

  const onSubmit = (data: Inputs) => {
    if (isFulfillmentService && isLabelValid() && isInvoiceValid()) {
      handleNotification('فایل لیبل را به سفارش اضافه نکرده‌اید', 'error');
      return
    }
    if (editMode) {
      setFormData(data);
      setDialog('confirmationOrder');
      return;
    }
    if (itemsInfo.length === 0) {
      handleNotification('کالایی را به سفارش اضافه نکرده‌اید', 'warn');
    } else {
      setFormData(data);
      setDialog('confirmationOrder');
    }
  };
  const isLabelValid = () => {
    return !labelLink && !labelFileName
  };
  const isInvoiceValid = () => {
    return !invoiceLink && !invoiceFileName
  };
  const createItemsToParcels = (body: AddItemCreateParcel) => {
    if (isVitrinOrderItem) {
      const {
        count,
        product,
        variant,
        price,
        fulfillmentVariantCode,
      } = body;
      setId(id + 1);
      const idItem = product?.id;
      const variantId = variant?.id;
      const dubItems = itemsInfo.filter((el: any) => el.variantId === variantId);
      if (dubItems.length > 0) {
        itemsInfo.map((el: any) => {
          if (el.variantId === variantId) {
            el.amount = +el.amount + +count;
          }
        });
      } else {
        setItemsInfo([
          ...itemsInfo,
          {
            id,
            productId: idItem,
            fulfillmentVariantCode,
            featureAndValues: variant?.features,
            type: product?.type,
            sellerName: variant?.sellerName,
            providerName: variant?.providerName,
            amount: count,
            productName: product?.name,
            productCode: product?.code,
            variantCode: variant?.code,
            variantId: variant,
            price,
          },
        ]);
      }
    } else {

      const {
        count,
        product,
        variant,
        boxCount,
        countOfBox,
        fulfillmentVariantCode,
      } = body;
      setId(id + 1);
      const idItem = product?.id;
      const variantId = variant?.id;
      const dubItems = itemsInfo.filter((el: any) => el.variantId === variantId);
      if (dubItems.length > 0) {
        itemsInfo.map((el: any) => {
          if (el.variantId === variantId) {
            el.amount = +el.amount + +count;
          }
        });
      } else {
        setItemsInfo([
          ...itemsInfo,
          {
            id,
            productId: idItem,
            fulfillmentVariantCode,
            featureAndValues: variant?.features,
            type: product?.type,
            sellerName: variant?.sellerName,
            providerName: variant?.providerName,
            amount: count,
            productName: product?.name,
            productCode: product?.code,
            variantCode: variant?.code,
            variantId: variant?.id,
            boxCount,
            countOfBox,
          },
        ]);
      }
    }
    setDialog("");
  };
  const setConfirmDelete = (body: any) => {
    setDialog('openConfirmDelete');
    setItemDeleted(body);
  };
  const deleteItemsFromOrder = () => {
    if (editMode) {
      deleteOrderItemOnEditMode({ id: itemDeleted.id })
    } else {
      deleteOrderItemOnCreateMode(itemDeleted.id)
    }
    setDialog("");
  };
  const handleLocations = (data: { lat: number; lng: number }) => {
    setLocations(data);
  };
  const onInvoiceDelete = () => {
    setInvoiceLink("")
    setInvoiceFile("")
    setIsInvoiceFileChange(true)
    setInvoiceFileName("")
  }
  const onLabelDelete = () => {
    setLabelLink("")
    setLabelFile("")
    setIsLabelFileChange(true)
    setLabelFileName("")
  }
  const handleSubmitOrder = async () => {
    try {
      const inventoryItems = itemsInfo.map((el: any) => {
        return {
          amount: el.amount,
          productCode: el.productCode,
          productName: el.productName,
          variantId: el.variantId,
          fulfillmentVariantCode: el.fulfillmentVariantCode
            ? el.fulfillmentVariantCode
            : null,
        };
      });
      const {
        origin,
        deliveryDate: deliver,
        deliveryType,
        deliveryTime,
        cost,
        weight,
        orderValue,
        packageCode,
        deliveryCode,
        codPaymentCode,
      } = formData;

      if (deliver.date) {
        var deliveryDate = convertPersianDigit2English(
          deliver.format('YYYY-MM-DD')
        );
      } else {
        var deliveryDate = deliver;
      }
      const payload = {
        orderType: "WITHOUT_CENTER",
        centerId: "",
        fulfillmentWarehouseId: origin,
        deliveryDate,
        deliveryStartTime: deliveryType == "VVIP" ? getCurrentTime() : convertPersianDigit2English(
          deliveryTime.substring(0, 2).concat(':00:00')
        ),
        deliveryEndTime: deliveryType == "VVIP" ? getVVIPTime() : convertPersianDigit2English(
          deliveryTime.substring(3, 5).concat(':00:00')
        ),
        items: editMode ? undefined : inventoryItems,
        id: editMode ? +orderId : undefined,
        fulfillmentLineId: isFulfillmentService ? 1 : null,
        codValue: cost,
        paymentType: cod ? 'COD' : 'ONLINE',
        weight,
        orderValue,
        packageCode,
        deliveryCode,
        codPaymentCode,
        isChangedLabelFile: !isFulfillmentService ? true : isLabelFileChange,
        isChangedReceiptFile: isInvoiceFileChange,
        deliveryLocationType: ["COURIER", "VIP"].includes(deliveryType) && deliveryLocationType ? "IN_RONAD" : "IN_CUSTOMER_ADDRESS"
      };
      const files = new FormData();
      files.append("receiptFile", (isInvoiceFileChange && invoiceFile) ? invoiceFile : new Blob([""]));
      files.append("labelFile", getlabelFile());
      if (editMode) {
        const body = new Blob([JSON.stringify({
          ...removeEmptyValueObject(payload),
          ...removeEmptyValueObject(collectCustomerInfo()),
        })], {
          type: 'application/json'
        })
        files.append("updateOrderDTO", body);


        updateOrder(files);
      } else {
        const body = new Blob([JSON.stringify({
          ...payload,
          ...removeEmptyValueObject(collectCustomerInfo()),
        })], {
          type: 'application/json'
        })
        files.append("createOrderDTO", body);
        createOrder(files);
      }
    } catch (err: any) {
      handleError(err.response);
    }
  };
  const getlabelFile = () => {
    if (!isFulfillmentService) {
      return new Blob([""])
    }
    if (isLabelFileChange && labelFile) {
      return labelFile
    }
    return new Blob([""])
  }
  const getOrderFile = async (type: string) => {
    try {
      const response = await getOrderFileReq(orderId, { fileType: type })
      const file = URL.createObjectURL(response.blob)
      return file;
    } catch (error: any) {
      handleError(error)
      return error;
    }
  }
  const collectCustomerInfo = () => {
    const {
      customerAddress,
      customerCity,
      customerMobileNumber,
      customerName,
      customerNationalCode,
      customerPhoneNumber,
      customerProvince,
      customerZipCode,
      deliveryType,
      description,
      trackingCode,
      orderTplType
    } = formData;
    return {
      customerCity,
      customerMobileNumber,
      customerName,
      customerNationalCode: customerNationalCode ? customerNationalCode : "1111111111",
      customerPhoneNumber: "02177777777",
      customerProvince,
      customerZipCode: customerZipCode ? customerZipCode : "1111111111",
      deliveryType: (deliveryType == "COURIER" && orderTplType == "EXPRESS_POST") ? "EXPRESS_POST" : deliveryType,
      orderTPLType: (deliveryType == "COURIER" && orderTplType == "EXPRESS_POST") ? null : ["EXPRESS_POST", "RONAD"].includes(orderTplType) ? null : orderTplType,
      description,
      receiptUrl: invoiceLink,
      fulfillmentAttachmentUrl: labelLink,
      trackingCode,
      customerLat: location?.lat,
      customerLon: location?.lng,
      customerAddress,
    };
  }
  const createOrder = async (body: any) => {
    try {
      setSubmitLoading(true)
      await ordersRepository.createOrder({ payload: { body } })
      handleNotification('سفارش شما با موفقیت ثبت گردید.', 'success');
      setSubmitLoading(false)
      history.push('/orders');
    } catch (err: any) {
      setSubmitLoading(false)
      if (
        err.response?.status == 400
      ) {
        if (err.response?.data?.fieldErrors?.length > 0) {
          err.response.data.fieldErrors.forEach((el: any) => {
            handleNotification(`مقدار فیلد ${el.field} اشتباه است`, 'error');
          });
        } else if (err.response.data?.title) {
          handleNotification(err.response.data.title, 'error');
        }
      } else if (
        err.response?.status == 406 &&
        err.response?.data?.errorKey == 'OrderItem.SkuId.not_acceptable'
      ) {
        err.response.data.errorList.forEach((el: any) => {
          handleNotification(
            `کالا با کد ${el.productCode} و کدتنوع ${el.variantCode} موجود نیست`,
            'error'
          );
        });
      } else if (err.response?.status == 409) {
        handleNotification(`مقدار فیلد کد رهگیری تکراری است`, 'error');
      } else {
        handleError(err.response);
      }
    }
  }
  const createOrderItem = async (payload: any) => {
    try {
      const { response } = await ordersRepository.createOrderItems({ payload })
      setItemsInfo(prev => [...prev, response.data])
      setDialog("");
    } catch (error) {
      handleError(error)
    }
  }
  const updateOrder = async (body: any) => {
    try {
      setSubmitLoading(true)
      await ordersRepository.newUpdateOrder({ payload: { body } })
      handleNotification('سفارش شما با موفقیت ویرایش گردید.', 'success');
      setSubmitLoading(false)
      history.push('/orders');
    } catch (error) {
      if (error.response.data.title) {
        handleNotification(error.response.data.title, 'error');
        return;
      }
      setSubmitLoading(false)
      handleError(error)
    }
  }
  const getOrder = async (payload: any) => {
    try {
      const response = await ordersRepository.getOrderWithId({ payload })
      setOrder(response.data)
    } catch (error) {
      handleError(error)
    }
  }
  const getOrderItems = async (payload: any) => {
    try {
      const response = await ordersRepository.getAllOrderItems({ payload })
      setOrderItems(response.data)
    } catch (error) {
      handleError(error)
    }
  }
  const deleteOrderItemOnEditMode = async (payload: any) => {
    try {
      await ordersRepository.deleteOrderItem({ payload })
      const newValue = items.filter((item: any) => item.id !== payload.id);
      const newValueInfo = itemsInfo.filter(
        (item: any) => item.id !== payload.id
      );
      setItemsInfo(newValueInfo);
      setItems(newValue)
      handleNotification('ایتم انتخابی با موفقیت حذف گردید', 'success');
    } catch (error) {
      handleError(error)
    }
  }
  const deleteOrderItemOnCreateMode = (id: string) => {
    const newValue = items.filter((item: any) => item.id !== id);
    const newValueInfo = itemsInfo.filter(
      (item: any) => item.id !== id
    );
    setItems(newValue);
    setItemsInfo(newValueInfo);
  }
  const handleSubmitOrderItems = (data: AddItemCreateParcel) => {
    const payload: orderItemsCreate = {
      amount: +data.count,
      productCode: data.productCode,
      fulfillmentVariantCode: data.fulfillmentVariantCode,
      productName: data.product?.name!,
      type: 'PRODUCT',
      variantId: data.variant?.id!,
      volume: 0,
      weight: data.product?.weight!,
    };

    createOrderItem({ body: payload, id: orderId });
    // history.go(0); 
    // forceUpdate();  
  };
  const handleCloseFactorModal = () => {
    if (dialog == "invoiceModal") {
      setInvoiceLink("")
    }
    if (dialog == "labelModal") {
      setLabelLink("")
    }
    setDialog("");
  };
  const handleInvoiceLink = (e: any) => {
    setInvoiceLink(e.target?.value);
  };
  const isLinkAddressButtonDisabled = () => {
    if (dialog == "invoiceModal") {
      return !invoiceLink || linkValidation(invoiceLink);
    } else {
      return !labelLink || linkValidation(labelLink);
    }
  }
  const labelFileChange = (e: any) => {
    setLabelFile(e.target.files[0])
    setLabelFileName(e.target.files[0].name)
    setIsLabelFileChange(true)
  }
  const invoiceFileChange = (e: any) => {
    setInvoiceFile(e.target.files[0])
    setInvoiceFileName(e.target.files[0].name)
    setIsInvoiceFileChange(true)
  }
  const fetchVideo = async () => {
    try {
      setVideoLoading(true)
      const response = await downloadVideo("SINGLE_ORDER")
      const reader = response?.body?.getReader();
      let buffer = [];
      while (1) {
        const { value, done } = await reader?.read();
        if (done) {
          const blob = new Blob(buffer);
          const blobUrl = URL.createObjectURL(blob);
          setVideo(blobUrl)
          break;
        }
        buffer.push(value);
      }
      setVideoLoading(false)
    } catch (err) {
      setVideoLoading(false)
      handleError(err.response)
    }
  }
  const onVideoOpen = () => {
    setDialog("VIDEO")
    fetchVideo()
  }
  //Force update Aryan
  // function forceUpdate() {
  //   setUpdateCount(updateCount+1);
  // }
  // Components Props
  const orderInfoProps = {
    form,
    cod,
    setCod,
    deliveryLocationType,
    setDeliveryLocationType,
    fulfillmentService: isFulfillmentService,
    setFulfillmentService: setIsFulfillmentService,
    order: order,
    notifType
  }
  return (
    <React.Fragment>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      
      <Typography variant="h6" component="h1" style={{marginBottom: "24px"}}>
            {editMode
              ? `${' '} ویرایش سفارش  ${orderId} `
              : `${' '} ایجاد سفارش `}
          </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid
          lg={12}
          md={12}
          container
          style={{ width: '100%' }}
        // spacing={4}
        >
          {/* Order Info Section */}
          <div style={{ backgroundColor: '#fff', padding: "24px", borderRadius: "4px" }}>
            <Typography variant="h6" component="h2" style={{ fontWeight: "bold" }}>
              اطلاعات سفارش
            </Typography>
            <OrderInfo {...orderInfoProps}>
              <OrderInputs editMode={editMode} form={form} cod={cod} isFulfillmentService={isFulfillmentService} deliveryLocationType={deliveryLocationType} />
              <Grid container item md={4} spacing={3} style={{ margin: 0 }}>
                <Grid item md={6}>
                  <FileWithLink
                    id="invoice"
                    handleChangeFileInput={invoiceFileChange}
                    file={invoiceFile}
                    getFile={() => getOrderFile("RECEIPT")}
                    fileName={invoiceFileName}
                    link={invoiceLink}
                    onClick={() => setDialog("invoiceModal")}
                    lable="افزودن فایل فاکتور (pdf)"
                    onDelete={onInvoiceDelete}
                    accept=".pdf"
                  />
                </Grid>
                <Grid item md={6}>
                  <FileWithLink
                    id="label"
                    handleChangeFileInput={labelFileChange}
                    file={labelFile}
                    getFile={() => getOrderFile("LABEL")}
                    fileName={labelFileName}
                    link={labelLink}
                    disabled={!isFulfillmentService}
                    onClick={() => setDialog("labelModal")}
                    lable="افزودن لیبل دیجی کالا (pdf)"
                    onDelete={onLabelDelete}
                    accept=".pdf"
                  />
                </Grid>
              </Grid>
            </OrderInfo>

            {/* Customer Info Section */}
            <Typography variant="h6" component="h2" style={{ fontWeight: "bold" }}>
              اطلاعات گیرنده
            </Typography>
            <CustomerInfo form={{
              errors,
              watch,
              setValue,
              getValues,
              register,
              control
            }} fulfillmentService={isFulfillmentService} cod={cod} deliveryLocationType={deliveryLocationType} handleLocations={handleLocations} location={location} />

            {/* Product List Section */}
            <Typography variant="h6" component="h2" style={{ fontWeight: "bold" }}>
              کالاهای سفارش
            </Typography>
            <ProductList
              isVitrinOrderItem={isVitrinOrderItem}
              setIsVitrinOrderItem={setIsVitrinOrderItem}
              setDialog={setDialog}
              itemsInfo={itemsInfo}
              setConfirmDelete={setConfirmDelete}
            />
            {/* Action Buttons */}
            <Grid
              container
              justifyContent="flex-end"
            >
              {/* <Button
                variant="outlined"
                color="primary"
                size="medium"
                onClick={() => window.history.back()}
                style={{
                  marginRight: 'auto',
                }}
                data-cy="cancelCreateOrder"
              >
                {'انصراف'}
              </Button> */}
              <Button
                type="submit"
                size="medium"
                variant="contained"
                color="primary"
                style={{
                  marginRight: '14px',
                }}
                data-cy="saveOrder"
              >
                {editMode ? 'ذخیره تغییرات' : 'ایجاد سفارش'}
              </Button>
            </Grid>
          </div>
        </Grid>
      </form>
      <ConfirmModal
        open={dialog === 'confirmationOrder'}
        onClose={() => setDialog("")}
        onSubmit={handleSubmitOrder}
        loading={submitLoading}>
        <Typography variant={'h6'}>
          {`آیا از ${editMode ? 'ویرایش' : 'ایجاد'} سفارش ${editMode ? orderId : 'جدید'
            } مطمئن هستید؟`}
        </Typography>
      </ConfirmModal>
      <Dialog
        open={["invoiceModal", "labelModal"].includes(dialog)}
        fullWidth
        onClose={handleCloseFactorModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent
          style={{ width: '100', marginBottom: '16px', overflow: 'hidden' }}
        >
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={handleCloseFactorModal}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.cancelIcon}>
            <Typography variant={'h6'}>وارد کردن آدرس</Typography>
          </div>
          <div>
            <Box mt={3} />
            <Grid xs={12} container justifyContent="center">
              {dialog == "invoiceModal" && (
                <Grid
                  container
                  item
                  xs={12}
                  alignItems="flex-end"
                  style={{ marginBottom: '16px' }}
                >
                  <div className={classes.item}>
                    <div style={{ width: '100%' }}>
                      <TextField
                        variant="outlined"
                        error={linkValidation(invoiceLink)}
                        fullWidth
                        type="text"
                        value={invoiceLink}
                        onChange={handleInvoiceLink}
                        helperText={
                          linkValidation(invoiceLink) &&
                          'مقدار وارد شده باید از نوع آدرس اینترنتی باشد'
                        }
                        label={
                          <Grid container alignItems="center">
                            <Icon
                              path={mdiPaperclip}
                              size={0.9}
                              color={theme.palette.gray.main}
                            />
                            <span style={{ marginRight: '5px' }}>
                              {'آدرس فایل مورد نظر خود را وارد کنید'}
                            </span>
                          </Grid>
                        }
                      />
                    </div>
                  </div>
                </Grid>
              )}
              {dialog == "labelModal" && (
                <Grid container item xs={12} alignItems="flex-end">
                  <div className={classes.item}>
                    <TextField
                      variant="outlined"
                      error={linkValidation(labelLink)}
                      fullWidth
                      type="text"
                      value={labelLink}
                      onChange={e => setLabelLink(e.target.value)}
                      helperText={
                        linkValidation(labelLink) &&
                        'مقدار وارد شده باید از نوع آدرس اینترنتی باشد'
                      }
                      label={
                        <Grid container alignItems="center">
                          <Icon
                            path={mdiPaperclip}
                            size={0.9}
                            color={theme.palette.gray.main}
                          />
                          <span style={{ marginRight: '5px' }}>
                            {'آدرس فایل مورد نظر خود را وارد کنید'}
                          </span>
                        </Grid>
                      }
                    />
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        </DialogContent>
        <Divider />
        <DialogActions className={classes.actionsBox}>
          <Button
            autoFocus
            onClick={handleCloseFactorModal}
            variant="outlined"
            color="primary"
            size="large"
            style={{ flex: '1 1 0' }}
          >
            {'انصراف'}
          </Button>
          <Button
            color="primary"
            fullWidth
            variant="contained"
            disabled={isLinkAddressButtonDisabled()}
            onClick={() => setDialog("")}
            size="large"
            style={{ flex: '1 1 0' }}
          >
            {'بارگذاری فاکتور'}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialog === 'openConfirmDelete'}
        onClose={() => setDialog("")}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent style={{ paddingTop: '0' }}>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {setDialog ? (
              <IconButton aria-label="close" onClick={() => setDialog("")}>
                <Icon path={mdiClose} size={'17px'} />
              </IconButton>
            ) : null}
          </div>

          <div
            className={classes.cancelTitle}
          >{`از لغو کالا با شناسه ${itemDeleted.id} مطمئن هستید؟`}</div>
          <Divider style={{ width: '100%', marginLeft: '0', marginRight: '0' }} />
        </DialogContent>
        <DialogActions style={{ padding: '15px' }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                onClick={() => setDialog("")}
                variant="outlined"
                color="primary"
                size="large"
              >
                {'انصراف'}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={deleteItemsFromOrder}
                size="large"
              >
                {'حذف آیتم'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <VideoModal src={video} onClose={() => setDialog("")} open={dialog === "VIDEO"} loading={videoLoading} />
      <Modal
        maxWidth="sm"
        onClose={() => setDialog("")}
        open={dialog === 'openAddItem'}
        title={
          <Typography
            variant="h6"
            style={{ textAlign: 'center', marginTop: '20px' }}
          >
            افزودن کالا به سفارش
          </Typography>
        }
        content={
          <Add
            addItem={(body: AddItemCreateParcel) =>
              editMode
                ? handleSubmitOrderItems(body)
                : createItemsToParcels(body)
            }
            fulfillmentService={isFulfillmentService}
            fulfillmentLineId={1}
            onClose={() => setDialog("")}
          />
        }
      />
      <Modal
        maxWidth="sm"
        onClose={() => setDialog("")}
        open={dialog === 'openAddVitrinItem'}
        title={
          <Typography
            variant="h6"
            style={{ textAlign: 'center', marginTop: '20px' }}
          >
            افزودن کالا به سفارش ویترین
          </Typography>
        }
        content={
          <AddVitrin
            addItem={(body: AddItemCreateParcel) =>
              editMode
                ? handleSubmitOrderItems(body)
                : createItemsToParcels(body)
            }
            fulfillmentService={isFulfillmentService}
            fulfillmentLineId={1}
            onClose={() => setDialog("")}
          />
        }
      />
    </React.Fragment >
  );
}

export default CreateOrder;
